"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("../../../control-components/ui-components/Button"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _Modal = require("@insided/shared/uikit/Modal");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PrivateMessageReportedModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PrivateMessageReportedModal, _PureComponent);

  var _super = _createSuper(PrivateMessageReportedModal);

  function PrivateMessageReportedModal() {
    (0, _classCallCheck2.default)(this, PrivateMessageReportedModal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PrivateMessageReportedModal, [{
    key: "render",
    value: function render() {
      var onIUnderstand = this.props.onIUnderstand;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: (0, _preact.h)(_phrase.default, {
          p: "privateMessages.reportSuccessModal.title"
        }),
        onClose: onIUnderstand
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.reportSuccessModal.text"
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        onClick: onIUnderstand
      }, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.reportSuccessModal.button"
      }))));
    }
  }]);
  return PrivateMessageReportedModal;
}(_preactCompat.PureComponent);

var _default = PrivateMessageReportedModal;
exports.default = _default;